var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDiagonalWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7487 0.542969C17.2018 0.542969 17.6363 0.722954 17.9567 1.04333C18.2771 1.3637 18.457 1.79822 18.457 2.2513V14.3326C18.457 14.7857 18.2771 15.2202 17.9567 15.5406C17.6363 15.861 17.2018 16.041 16.7487 16.041C16.2956 16.041 15.8611 15.861 15.5407 15.5406C15.2204 15.2202 15.0404 14.7857 15.0404 14.3326V6.37693L3.45959 17.956C3.13739 18.2672 2.70586 18.4394 2.25794 18.4355C1.81002 18.4316 1.38155 18.2519 1.06481 17.9352C0.748074 17.6185 0.56841 17.19 0.564518 16.7421C0.560625 16.2942 0.732817 15.8626 1.044 15.5404L12.6231 3.95964H4.66909C4.21601 3.95964 3.78149 3.77965 3.46111 3.45928C3.14074 3.1389 2.96075 2.70438 2.96075 2.2513C2.96075 1.79822 3.14074 1.3637 3.46111 1.04333C3.78149 0.722954 4.21601 0.542969 4.66909 0.542969H16.7487Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDiagonalWhite);
export default __webpack_public_path__ + "static/media/arrowDiagonalWhite.2407093185d2da489bebe00869dfc4ec.svg";
export { ForwardRef as ReactComponent };